module.exports = __webpack_public_path__ + "img/UN_Women_Spurning05.e28a7373.gif";